import { createContext, useContext, useState, useEffect } from "react";
import { getT } from "../data/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("kumbh_lang") || "en");
  const t = getT(lang);

  const setLanguage = (code) => {
    setLang(code);
    localStorage.setItem("kumbh_lang", code);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
